<template>
  <div class="app-main-content">
    <div class="main-content" style="overflow: auto;">
      <div v-show="!isPreview" style="width: fit-content">
        <div style="display: flex">
          <div v-for="block in blocks" :key="block.pagePart.pagePartName" class="section" style="width: 301px;margin-right: 5px;">
            <el-form label-width="140px" label-position="right">
              <span :class="'title' + (readonly ? ' not-click' : '')" style="width: 100%;">
                {{ block.customLabel || block.sysLabel }}
              </span>
              <el-form-item label=" ">
                <span class="element-column-text" :title="$t('SeaExport.Display')">{{ $t('SeaExport.Display') }}</span>
                <span class="element-column-text" :title="$t('SeaExport.Required')">{{ $t('SeaExport.Required') }}</span>
                <span class="element-column-text" :title="$t('SystemMaintenance.Alias')" style="width: 80px;">{{ $t('SystemMaintenance.Alias') }}</span>
              </el-form-item>
              <el-form-item v-for="element in block.uiCustomElementList" :key="block.pagePart.pagePartName + '-' + element.pagePartElement.elementName">
                <span slot="label" :class="element.isRequire ? 'blue' : ''">{{ element.sysLabel }}</span>
                <el-checkbox
                  v-model="element.isDisplay"
                  :disabled="readonly || element.isRequire || !element.branchIsDisplay"
                  class="element-column-content"
                  @change="onDisplayChange(block, element)"
                />
                <el-checkbox
                  v-model="element.isRequire"
                  disabled
                  class="element-column-content"
                />
                <span class="element-column-text" :title="element.customLabel" style="width: 80px;pointer-events: auto;">{{ element.customLabel }}</span>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
      <!-- 预览 -->
      <slot v-if="isPreview" name="preview" />
    </div>
  </div>
</template>

<script>
import gridTab from '@/views/cargo/v0/SystemMaintenance/components/pageUICustom/gridTab'

export default {
  name: 'UserGridTab',
  extends: gridTab
}
</script>

<style lang="scss" scoped>
  @import '../pageUICustom/base.scss';
</style>
